import { NgModule } from '@angular/core';
import {TelemetryComponent} from './telemetry.component';
import { Routes, RouterModule } from '@angular/router';
import { Route } from '@app/core/route.service';
import { CanDeactivateGuard } from '../core/CanDeactivateGuard';

const routes: Routes = Route.withShell([
  { path: 'telemetry', component: TelemetryComponent, data: { title: 'Telemetry' }, canDeactivate: [CanDeactivateGuard] }
]);

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule],
  declarations: []
})
export class TelemetryRouteModule { }
